const customerLoginType = {
	customerId: 0,
	email: 1,
} as const

export default customerLoginType

export type CustomerLoginType = keyof typeof customerLoginType
